import { PayloadAction } from '@reduxjs/toolkit';
import { put, takeEvery } from 'redux-saga/effects';

import { AUTH_LOGIN_SAGA } from 'reduxToolkit/actions';
import { csrfSlice, loginSlice, commonSlice } from 'reduxToolkit/reducers';
import { loginReducerTypes } from 'types';
import { apiCall, apiRoutes, getApiErrorMessage } from 'utils/helpers';

const { loginStart, loginSuccess, loginFailed } = loginSlice.actions;
const { exceptionHandlerRequest } = commonSlice.actions;
const { csrfFailed } = csrfSlice.actions;

const loginSaga = function* (payloadData: PayloadAction<loginReducerTypes.ILoginForm>): any {
    yield put(loginStart(payloadData.payload));
    try {
        const { email, password } = payloadData.payload;
        const data = {
            email,
            password,
            is_spa: false,
        };

        const csrfResponse = yield apiCall({ ...apiRoutes.csrf });
        if (csrfResponse.status === 204) {
            const response = yield apiCall({ data, ...apiRoutes.login });

            if (response.status === 200) {
                yield put(loginSuccess(response.data));
            } else {
                const errorData = {
                    status: false,
                    error: getApiErrorMessage(response),
                };
                yield put(loginFailed(errorData));
            }
        } else {
            yield put(csrfFailed());
        }
    } catch (error) {
        yield put(exceptionHandlerRequest(error));
    }
};

export const takeLoginRequest = function* () {
    yield takeEvery(AUTH_LOGIN_SAGA, loginSaga);
};
